module.exports = "https://dev.stanwinstonschool.com/godzilla_kingofthemonsters_poster_org Large.b7bf16f5c0a71398b147923c05e5b8be.jpeg";